module.exports = __webpack_public_path__ + "img/kavya.e905054a.jpeg";